import { ContentType } from '@/@types/common'
import { type Post, PostStatus } from '@/@types/post'
import useUniversalNavigate from '@/utils/hooks/useUniversalNavigate'
import { POST_TYPE_TO_ROUTE_MAPPING } from '@/utils/route'
import { css } from '@emotion/react'
import { Warn2FilledIcon } from '@ruguoapp/jike-fe-icons'
import { type HTMLAttributes, type MouseEvent, useCallback } from 'react'
import PostCard from './PostTargetCard/PostCard'

export interface PostTargetProps extends HTMLAttributes<HTMLDivElement> {
	data: Post | undefined
}

export default function PostTarget({ data, ...props }: PostTargetProps) {
	const navigate = useUniversalNavigate()
	const handleCardClick = useCallback(
		(e: MouseEvent) => {
			e.stopPropagation()
			const postId = data?.target?.id
			const username = data?.target?.user?.username
			const type = data?.targetType && POST_TYPE_TO_ROUTE_MAPPING[data.targetType]

			if (!postId || !username || !type) {
				return
			}

			navigate(
				{
					to: '/u/$username/$type/$id',
					params: {
						username,
						id: postId,
						type: type,
					},
				},
				e
			)
		},
		[data?.target?.id, data?.target?.user?.username, data?.targetType, navigate]
	)

	if (!data || !data.target || !data.targetType) {
		return null
	}

	if (data.target.status === PostStatus.DELETED) {
		return (
			<div
				css={css`
					display: flex;
					justify-content: center;
					align-items: center;
					gap: 4px;
					height: 70px;
					background-color: var(--bg-on-body-3);
					padding: 10px;
					border-radius: 10px;
					color: var(--tint-tertiary);
					font-size: 14px;
					font-weight: 500;
				`}
			>
				<Warn2FilledIcon
					css={css`
						width: 20px;
						height: 20px;
					`}
				/>
				内容已删除
			</div>
		)
	}

	switch (data.targetType) {
		case ContentType.POST:
			return <PostCard data={data.target} onClick={handleCardClick} />
		case ContentType.REPOST:
			return <PostCard data={data.target} onClick={handleCardClick} />
		case ContentType.PERSONAL_UPDATE:
			return null
	}
}
